import PropTypes from "prop-types";
import React from "react";

function WrapperTimelineVertical({ children }) {
  return <ul className="verti-timeline list-unstyled">{children}</ul>;
}

WrapperTimelineVertical.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WrapperTimelineVertical;
